import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { emptyPassport } from '../utils/passports';

export default function StudentPassportsFields({
  passports,
  onChange,
  allowAddRemove = true,
}) {
  const list = passports?.length ? passports : [emptyPassport()];

  const update = (idx, field, value) => {
    onChange(list.map((p, i) => (i === idx ? { ...p, [field]: value } : p)));
  };

  const add = () => onChange([...list, emptyPassport()]);

  const remove = (idx) => {
    const next = list.filter((_, i) => i !== idx);
    onChange(next.length ? next : [emptyPassport()]);
  };

  return (
    <>
      {list.map((passport, idx) => (
        <React.Fragment key={idx}>
          <div className="col-md-4">
            <div className="form-group">
              <label>{idx === 0 ? 'Passport No.' : `Passport No. #${idx + 1}`}</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="text"
                  className="input-field form-control"
                  value={passport.number || ''}
                  placeholder={idx === 0 ? 'Passport number' : `Passport number #${idx + 1}`}
                  onChange={(e) => update(idx, 'number', e.target.value)}
                />
                {allowAddRemove && list.length > 1 && (
                  <button
                    type="button"
                    className="btn-icon btn-delete"
                    title="Remove"
                    onClick={() => remove(idx)}
                    style={{ width: '38px', height: '38px', flexShrink: 0 }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Date of Issue</label>
              <input
                type="date"
                className="input-field form-control date-input"
                value={passport.issueDate ? String(passport.issueDate).split('T')[0] : ''}
                onChange={(e) => update(idx, 'issueDate', e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Place of Issue</label>
              <input
                type="text"
                className="input-field form-control"
                value={passport.placeOfIssue || ''}
                onChange={(e) => update(idx, 'placeOfIssue', e.target.value)}
              />
            </div>
          </div>
        </React.Fragment>
      ))}
      {allowAddRemove && (
        <div className="col-md-12 no-print">
          <div className="form-group">
            <button
              type="button"
              className="btn-secondary btn-sm"
              style={{ fontSize: '12px' }}
              onClick={add}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Passport Number
            </button>
          </div>
        </div>
      )}
    </>
  );
}
